import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Control from '../views/Control.vue'
import Access from '../views/Access.vue'

Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Access
  },
  {
    path: '/control',
    name: 'Control',
    component: Control
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
